import React, { useState, useEffect, useRef } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { SVGPureIcon } from '@/ui';
import { getMcpToolsConfig } from '@shared/constants/mcp';
import CircleLoading from '@/components/ani/circle-loading';
import { HelperCore } from '@/common/helper';
import connectionLineStore from '@/components/chat-history/connection-line/store';
const McpToolsSearch = observer((props) => {
  const {
    className = '',
    event,
    mcpStore,
    messageItem,
  } = props;

  // console.log('McpToolsSearch', event.buType);
  
  const [autoScroll, setAutoScroll] = useState(true);

  const hasDone = event.status == "success";
  const config = getMcpToolsConfig(event);
  if(config.hidden){
    return null;
  }

  const toolConfig = mcpStore.getFixedToolText(event);
  let disabled = false;
  try{
    disabled = toolConfig.disabled;
  } catch(e){}

  const refScroll = useRef(null);
  useEffect(() => {
    if (!autoScroll) {
      return;
    }
    const el = refScroll?.current;
    el?.scrollTo({
      left: 0,
      top: el.scrollHeight,
      behavior: 'smooth',
    });
  }, [event.children]);

  const mouseenter = () => {
    setAutoScroll(false)
  }

  const mouseleave = () => {
    setAutoScroll(true)
  }
  
  useEffect(() => {
    const el = refScroll?.current;
    el?.addEventListener('mouseenter', mouseenter);
    el?.addEventListener('mouseleave', mouseleave);

    return () => {
      el?.removeEventListener('mouseenter', mouseenter);
      el?.removeEventListener('mouseleave', mouseleave);
    }
  }, []);

  useEffect(() => {
    if (event?.buType === 'task_add_to_cart') {
      if (!mcpStore.showRightPanel && !HelperCore.isPhone()) {
        mcpStore.setShowRightPanel(true);
      }
    }
  }, [event]);
    
  const id = `${messageItem?.msg_id || ''}_${event?.planStepId || ''}`;

  return (
    <div 
      className={`px-10px w-full flex flex-col bg-black bg-opacity-3 hover:bg-opacity-6 rounded-12px ${className}`}
      data-id={id}
      onClick={
        (e) => {
          if(!mcpStore){
            return;
          }
          if(disabled){
            return;
          }
          
          if(messageItem){
            mcpStore.setPanelMessageId(messageItem.msg_id);
          }
          mcpStore.setCurrentPanelId(event.planStepId, true);
          connectionLineStore.updatePoint(id);
        }
      }
      >
      <div className="flex w-full h-32px items-center" data-type={event?.buType}>
        <SVGPureIcon name={`${config.getIcon ? config.getIcon(event) : config.icon}`} className='size-18px mr-3px flex-shrink-0' />
        <div className="text-13px text-black text-opacity-70 leading-18px flex items-center flex-shrink max-w-8/10">
            <div className="flex-shrink-0">
              {event?.buType === 'task_add_to_cart' ? '我正在帮你将商品加入购物车' : '我正在搜索'}
            </div>
            <div className="font-bold text-black text-opacity-70 mx-3px flex-shrink truncate">{event.buResult?.result?.content || ''}</div>
            <div className="flex-shrink-0">
              {event?.buType === 'task_add_to_cart' ? '' : '的相关内容'}
            </div>
        </div>
        {/* loading/done */}
        {
          event.status == "failed"
          ? <SVGPureIcon name={`mcp_error`} className='size-16px ml-6px text-[#FF3B30] flex-shrink-0' />
          : !hasDone
          ? (
            event.status == 'running'
            ? <CircleLoading className="!size-16px ml-6px flex-shrink-0" />
            : null
          )
          : <SVGPureIcon name={`done`} className='size-16px ml-6px text-[#33C481] flex-shrink-0' />
        }
      </div>

      <div 
        ref={refScroll}
        className="max-h-115px mt-3px mb-10px rounded-12px nw-scrollbar-thin overflow-y-auto bg-white"
        onClick={
          (event) => {
            event.stopPropagation();
          }
        }>
        {
          (event.children || []).map((itemLevel3, indexLevel3) => {
            const {
              desc = '',
              desc2 = '',
              content = '',
              url = '',
              like_status = 0,
            } = itemLevel3?.buResult?.result;

            let icon = 'mcp_tool_view';
            let color = 'text-[#000000]';
            if (like_status === 1) {
              icon = 'mcp_tool_like';
              color = 'text-[#FF7307]';
            }else if (like_status === 2) {
              icon = 'mcp_tool_notice';
              color = 'text-[#FF7307]';
            }
            return (
              <div
                className="bg-white px-12px py-8px  text-13px text-black cursor-default leading-22px break-all"
                key={`tools-search-${indexLevel3}`}
              >
                <SVGPureIcon name={icon} className={`size-16px min-w-16px mr-5px mt-[-2px] inline-block align-middle ${color}`} />
                <span className=''>
                  { like_status === 0 ? desc : (like_status === 1 || like_status === 2 ? '我注意到' : '') }
                </span>
                {
                  url ? (
                    <a className='!text-black !text-opacity-50 mx-5px !hover:underline' href={url} target='_blank' rel='noopener'>{content}</a>
                  ) : (
                    <span className='text-black text-opacity-50 mx-5px'>{content}</span>
                  )
                }
                { like_status === 0 ? desc2 : (like_status === 1 ? '的点赞收藏评论数量较高，将对其着重关注' : (like_status === 2 ? '的点赞量较低，将不作为参考' : '')) }
              </div>
            )
          })
        }
      </div>

    </div>
  )
});
export default McpToolsSearch;